"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventoryCreateStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class InventoryCreateStore {
    constructor() {
        this.inventory = {};
        this.ndcs = {};
        this.ndcsProducts = {};
        this.loadNDCs = async (search) => {
            this.ndcs = { loading: true };
            const result = await api_1.NDCEndpoint.list.apiCall({
                query: { start: 0, count: 0, search },
            });
            if (api_1.isError(result)) {
                this.ndcs = { error: result.code };
            }
            else {
                this.ndcs = { value: result.ndcs };
            }
        };
        this.createInventory = async (addToAllSites, ndc) => {
            this.inventory = { loading: true };
            const result = await api_1.InventoryEndpoint.create.apiCall(null, {
                addToAllSites,
                ndc,
            });
            if (api_1.isError(result)) {
                this.inventory = { error: result.code };
                return false;
            }
            else {
                this.inventory = {};
                return result.inventory;
            }
        };
        this.pullPackage = async (ndc) => {
            const result = await api_1.NDCEndpoint.find.apiCall(null, { ndc });
            const site = await this.createInventory(false, result);
            return site.id ? site.id : false;
        };
        this.connectInventorytoSite = async (inventorydata, siteid) => {
            await api_1.InventoryEndpoint.linkinventorytosite.apiCall(null, {
                inventorydata,
                siteid,
            });
        };
        this.manualCreateInventory = async (inventoryItem) => api_1.InventoryEndpoint.manualCreate.apiCall(null, { inventoryItem });
    }
}
__decorate([
    mobx_1.observable
], InventoryCreateStore.prototype, "inventory", void 0);
__decorate([
    mobx_1.observable
], InventoryCreateStore.prototype, "ndcs", void 0);
__decorate([
    mobx_1.observable
], InventoryCreateStore.prototype, "ndcsProducts", void 0);
__decorate([
    mobx_1.action
], InventoryCreateStore.prototype, "loadNDCs", void 0);
__decorate([
    mobx_1.action
], InventoryCreateStore.prototype, "createInventory", void 0);
__decorate([
    mobx_1.action
], InventoryCreateStore.prototype, "connectInventorytoSite", void 0);
__decorate([
    mobx_1.action
], InventoryCreateStore.prototype, "manualCreateInventory", void 0);
exports.inventoryCreateStore = new InventoryCreateStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-create/store.ts
// module id = 2445
// module chunks = 0